/// <reference path="../_references.ts"/>
module App.Validations {
	interface IValidation {
		pattern?: RegExp;
		message: string;
	}

	export class Validations {
		static get getValidations() {
			return new Validations();
		}

		general: IValidation;
		name: IValidation;
		street: IValidation;
		city: IValidation;
		state: IValidation;
		zip: IValidation;
		phone: IValidation;
		email: IValidation;
		creditCard: IValidation;
		numberOnly: IValidation;
		dollarAmount: IValidation;
		required: IValidation;
		min: IValidation;
		max: IValidation;

		constructor() {
			this.general = {
				pattern: /^[0-9a-zA-Z#-\s,.'&"$!():;%?]+$/,
				message: 'Invalid entry. The only special characters allowed are # - , . \'&"$!():;%'
			};
			this.name = {
				pattern: /^[0-9a-zA-Z#-\s,.'&"$!]+$/,
				message: 'Invalid entry. The only special characters allowed are , . \' & " $ !'
			};
			this.street = {
				pattern: /^[0-9a-zA-Z#-\s,.]+$/,
				message: 'Invalid entry. The only special characters allowed are # - , .'
			};
			this.city = {
				pattern: /^[0-9a-zA-Z-'&.\s]+$/,
				message: 'Invalid entry. The only special character allowed are - \' &.'
			};
			this.state = {
				message: 'Must be a valid US state or province. Ex: NY'
			};
			this.zip = {
				pattern: /^(\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1})$/,
				message: 'Must be a valid US or Canadian Postal Code'
			};
			this.phone = {
				pattern: /(?:\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}/,
				message: 'Must be a valid 10 digit phone number. Ex: (222) 555-1212'
			};
			this.email = {
				pattern: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
				message: 'Must be a valid email address. Ex: someone@anydomain.com'
			};
			this.creditCard = {
				pattern: /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/i,
				message: 'Must be a valid credit card.'
			};
			this.numberOnly = {
				pattern: /^[0-9]*$/i,
				message: 'Only numbers 0-9 are allowed.'
			};
			this.dollarAmount = {
				pattern: /^[0-9]+\.?[0-9]?[0-9]?$/i,
				message: 'Invalid entry. Ex: 12.12, 12., 12'
			};
			this.max = {
				message: 'Value exceeds maximum allowed.'
			};
			this.min = {
				message: 'Value below minimum allowed.'
			};
			this.required = {
				message: 'Value is required'
			};
		}
	}

	angular.module('helpers.validations', []).constant('Validations', Validations.getValidations);
}
